module.exports = __webpack_public_path__ + "img/pic_05@2x.700b67ca.png";